export default "__VITE_ASSET__1SYvOXs2__"